"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCommonProps = exports.commonProps = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * List of potential values components can pick from
 */

var commonProps = exports.commonProps = ["width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "background", "gap", "alignSelf", "justifySelf", "gridColumn", "gridRow", "flex", "flexGrow", "flexShrink", "flexBasis", "borderRadius", "border", "borderWidth", "borderStyle", "borderColor", "boxShadow", "display", "position", "inset", "top", "right", "bottom", "left", "zIndex", "overflow", "overflowX", "overflowY", "opacity", "cursor", "verticalAlign", "textAlign", "aspectRatio", "objectFit", "objectPosition"];
var defaultCommonProps = exports.defaultCommonProps = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "flex", "flexGrow", "flexShrink", "alignSelf", "justifySelf", "gridColumn", "gridRow"];